<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-select v-model="location_type" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in location_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-select v-model="prefer_id" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in prefer_status"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addEdit"
                >新增</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addFile"
                >上传</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="药名" align="center"></el-table-column>
                <el-table-column prop="brand" label="品牌" align="center"></el-table-column>
                <el-table-column prop="specification" label="规格" align="center"></el-table-column>
                <el-table-column prop="price" label="价格(元)" align="center"></el-table-column>
                <el-table-column label="药房" align="center">
                    <template slot-scope="scope">
                        {{getProviderName(scope.row.provider_id)}}
                    </template>
                </el-table-column>
                <el-table-column prop="stock" label="库存" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 2">已下架</span>
                        <span v-else>已上架</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button 
                            v-if="scope.row.status == 2"
                            type="text"
                            @click="statusEdit(scope.row, 1)"
                        >上架</el-button>
                        <el-button 
                            v-else
                            type="text"
                            @click="statusEdit(scope.row, 2)"
                        >下架</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="药名：" prop="name">
                    <el-input
                     v-model="form.name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="品牌：" prop="brand">
                    <el-input
                     v-model="form.brand" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="规格：" prop="specification">
                    <el-input
                     v-model="form.specification" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="价格：" prop="price">
                    <el-input
                     v-model="form.price" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="药房：" prop="provider_id">
                    <el-select v-model="provider_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in providers"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存：" prop="stock">
                    <el-input
                     v-model="form.stock" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="window_prefer_id">
                    <el-select v-model="window_prefer_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in prefer_status"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="fileVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="fileForm" :model="file_form" label-width="60px">
                <el-form-item label="药房：" prop="window_provider_id">
                    <el-select v-model="provider_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in providers"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文件：">
                    <el-upload
                    class="avatar-uploader"
                    action
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    >
                        <p v-if="file_form.download_path" class="avatar">{{file_form.download_path}}</p>
                        <em v-show="!file_form.download_path && !uploading" class="el-icon-plus avatar-uploader-icon"></em>
                        <em class="el-icon-loading avatar-uploader-icon" v-show="uploading"></em>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../api/dorisApiConfig'
export default {
    name: 'medicineslist',
    data() {
        return {
            location_types: [{"name": "全部", "id": ''}],
            location_type: '',
            providers: [],
            provider_id: '',
            window_prefer_id: '',
            prefer_status:[
                {'name': '已上架', 'id': 1},
                {'name': '已下架', 'id': 2}
            ],
            prefer_id: 1,
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            loading: false,
            multipleSelection: [],
            editVisible: false,
            is_add: false,
            form: {},
            window_provider_id: '',
            rules: {
                name: [{ required: true, message: "请填写药名", trigger: "blur" }],
                brand: [{ required: true, message: "请填写品牌", trigger: "blur" }],
                price: [{ required: true, message: "请填写价格", trigger: "blur" }],
                stock: [{ required: true, message: "请填写库存", trigger: "blur" }],
                specification: [{ required: true, message: "请填写规格", trigger: "blur" }]
            },
            file_form:{},
            fileVisible: false,
            uploading: false
        };
    },
    created() {
        let that = this;
        http.get("admin/providers",{params: {'page': 1, 'page_size': 30}}).then(function(res) {
            that.providers = res.data.data.providers;
            that.location_types = that.location_types.concat(that.providers);
        });
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        getProviderName(id){
            var item = _.filter(this.providers, function(selector){ return selector.id == id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.location_type){
                params['provider_id'] = that.location_type;
            }
            params['status'] = that.prefer_id;
            http.get("admin/products",{params: params}).then(function(res) {
                that.tableData = res.data.data.products;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    product_id: row.id
                }
                http.delete("admin/product", {params: params}).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                });
            })
            .catch(() => {});
        },
        onInput(){
            this.$forceUpdate();
        },
        statusEdit(row, status){
            let that = this;
            let params = {product_id: row.id, status: status}
            if(row.status == 2){
                that.$confirm('是否上架?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    http.post("admin/product/status", params).then(function(res) {
                        // console.log(res);
                        if (res.data.status_code == 200) {
                            that.$message.success('上架成功');
                            that.getData();
                        }
                    });
                })
                .catch(() => {});
            }else{
                that.$confirm('是否下架?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    http.post("admin/product/status", params).then(function(res) {
                        // console.log(res);
                        if (res.data.status_code == 200) {
                            that.$message.success('显示下架');
                            that.getData();
                        }
                    });
                })
                .catch(() => {});
            }
        },
        // 编辑操作
        handleEdit(row) {
            this.form = {
                product_id: row.id,
                name: row.name,
                brand: row.brand,
                price: row.price,
                stock: row.stock,
                specification: row.specification
            }
            this.provider_id = row.provider_id;
            this.window_prefer_id = row.status;
            this.is_add = false;
            this.editVisible = true;
        },
        addFile(){
            this.file_form = {
                download_path: ''
            }
            if(this.location_type == ''){
                this.provider_id = this.providers[0]['id'];
            }else{
                this.provider_id = this.location_type;
            }
            this.fileVisible = true;
        },
        beforeAvatarUpload(file) {
            let that = this;
            const isPackage = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            if (isPackage) {
                var ossData = new FormData();
                var filename = file.name;
                ossData.append("work_path", "common/product");
                ossData.append("bucket", "family-tcm");
                ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
                ossData.append("rewrite", "1");
                ossData.append("file_name", filename);
                ossData.append("file", file);
                that.uploading = true;
                http.post("admin/upload/product?provider_id="+that.provider_id, ossData).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.downloadUrl = "common/product/" + filename;
                        that.form.download_path = filename;
                        that.$message.success(`上传成功`);
                        that.getData();
                    }
                    that.uploading = false;
                    that.fileVisible = false;
                });
            } else if (!isPackage) {
                this.$message.error("上传文件不是文档");
            }
            return isPackage;
        },
        addEdit(){
            this.form = {
                name: '',
                brand: '',
                price: '',
                stock: '',
                specification: ''
            }
            if(this.location_type == ''){
                this.provider_id = this.providers[0]['id'];
            }else{
                this.provider_id = this.location_type;
            }
            this.window_prefer_id = 1;
            this.is_add = true;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        name: that.form.name,
                        brand: that.form.brand,
                        price: that.form.price,
                        provider_id: that.provider_id,
                        stock: that.form.stock,
                        specification: that.form.specification,
                        status: that.window_prefer_id
                    };
                    if(that.is_add){
                        http.post("admin/product", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }else{
                        params['product_id'] = that.form.product_id;
                        http.put("admin/product", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
